export default __webpack_public_path__ + "static/media/soldstmp.46538b5b.png";